module.exports = __webpack_public_path__ + "static/img/join-us.44753d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/abouts/join-us.png
// module id = yg+q
// module chunks = 1